import { css } from '@emotion/core';
import { typography, fontWeights } from '../../../styles/typography';
import { colorsPalette, shadows } from '../../../styles/colors';
import MediaQueries from '../../../styles/Grid/MediaQueries';
import { VIEWPORTS, Edges } from '../../../styles/Grid/GridSizes';

export const buttonWidth = 74;
export const maxCardsPerSlide = 7;
export const containerWidth = buttonWidth * maxCardsPerSlide;

// This container is only needed as parent of innerContainerCss, since it
// behaves as inline-block. Not using this may cause unexpected layout flow.
export const containerCss = css({});

export const innerContainerCss = css({
  position: 'relative',
  display: 'inline-block',

  // Hack to make the component to have 100% on mobile
  marginLeft: -Edges[VIEWPORTS.sm],
  width: '100vw',
  [MediaQueries.mdAndUp]: {
    marginLeft: 0,
    width: 'auto',
    paddingLeft: 38,
  },
});

export const sliderCss = css({
  overflowX: 'scroll',
  '::-webkit-scrollbar': {
    WebkitAppearance: 'none',
  },
  [MediaQueries.mdAndUp]: {
    width: containerWidth,
    boxSizing: 'initial',
    overflow: 'hidden',
    padding: '40px 0',
  },
});

export const buttonsContainerCss = css({
  // Resets box sizing to add padding inside the scroll without affecting calculated padding.
  boxSizing: 'initial',
  padding: '40px 18px',
  // Disables the transform applied by the component on mobile only.
  [MediaQueries.sm]: {
    transform: 'none !important',
  },
  [MediaQueries.mdAndUp]: {
    padding: 0,
    transition: 'transform 0.3s',
  },
});

export const dayButtonCss = css({
  height: 80,
  width: 64,
  display: 'inline-block',
  color: colorsPalette.black,
  backgroundColor: colorsPalette.white,
  borderRadius: 2,
  border: `1px solid ${colorsPalette.grey20}`,
  margin: '0 5px',
  cursor: 'pointer',
  boxSizing: 'border-box',
  transition: 'box-shadow 0.2s',

  ':disabled': {
    backgroundColor: colorsPalette.grey10,
    color: colorsPalette.grey60,
  },

  ':hover:not(:disabled)': {
    outline: 0,
    borderColor: colorsPalette.white,
    boxShadow: shadows.shadow40,
  },
});

export const dayButtonSelectedCss = css({
  backgroundColor: colorsPalette.teal,
  borderColor: colorsPalette.teal,
  color: colorsPalette.white,

  ':hover:not(:disabled)': {
    borderColor: colorsPalette.teal,
  },
});

export const dayButtonTopLabelCss = css(typography.effra22, {
  display: 'block',
  lineHeight: 1,
  fontWeight: fontWeights.medium,
  marginBottom: 10,
});

export const dayButtonBottomLabelCss = css(typography.effra12, {
  display: 'block',
  color: colorsPalette.grey60,
  textTransform: 'uppercase',
});

export const selectedLabelCss = css({
  color: colorsPalette.white,
});

const arrowButtonBaseCss = css({
  position: 'absolute',
  border: 0,
  cursor: 'pointer',
  width: 50,
  height: 50,
  backgroundColor: colorsPalette.transparent,
  top: '50%',
  transform: 'translateY(-50%)',
});

export const leftArrowButtonCss = css(arrowButtonBaseCss, {
  left: -12,
});

export const rightArrowButtonCss = css(arrowButtonBaseCss, {
  right: -50,
});

export const iconCss = css({
  fontSize: 20,
});
